'use client';
import NextLink from '@/components/next-link';
import HeartIcon from '@/components/ui/icons/heart-icon';
import useWishlist from '@/store/wishlist.store';

const Wishlist = () => {
  const wishlist = useWishlist((state) => state.wishlist);

  return (
    <NextLink
      href='/favourite'
      className='border border-y-0 border-[#EBEBEB] px-5 max-lg:hidden'
    >
      <span className='relative flex size-10 items-center justify-center rounded-full bg-[#F6F6F7]'>
        <HeartIcon className='size-4' />
        <span className='absolute end-0 top-0 z-10 flex size-3.5 items-center justify-center rounded-full bg-[#8B0000] text-[10px] font-bold text-white'>
          {wishlist?.length}
        </span>
      </span>
    </NextLink>
  );
};

export default Wishlist;
